import {createSlice} from '@reduxjs/toolkit';
import _ from 'lodash';
import moment from 'moment/moment';
import API from '../../app/api';
import 'moment-timezone';
import {
    admissionStatusTypes,
    admissionViewTypes,
    CalendarViews,
    contentViewTypes,
    SessionsTime,
    StatusTypes,
} from '../../pages/bookedAdmissions/bookAdmissionUtils';

export const bookedAdmissions = createSlice({
    name: "bookedAdmissions",
    initialState: {

        operations: [],
        operationsFiltered: [],
        operationsObject: {},

        sessions: [],
        sessionsFiltered: [],

        worklistOperations: [],
        worklistOperationsLength: 0,

        unscheduledOperation: [],
        unscheduledOperationLength: 0,

        operationsStatus: admissionStatusTypes.UNSCHEDULED,
        startDay: null,
        calendarView: CalendarViews.month,
        markedOperation: null,
        selectedTheatre: "",
        selectedTime: SessionsTime.AM,
        admissionType: null,
        jumpToTheatre: "",
        config: null,
        theatresDict: [],
        allTheatresDict: [],
        specialtiesDict: [],

        specialtiesFilter: [],
        consultantsFilter: [],
        surgeonsFilter: [],
        anaesthetistsFilter: [],

        patientsFilter: null,
        procedureFilter: null,
        worklistFilterColumns: null,
        filtersStatus: StatusTypes.ACTIVE,
        filterPriority: [],
        filterAnaestheticType: [],
        hourHeight: 400,
        operationToScroll: null,
        admissionContentView: contentViewTypes.SCHEDULE,
        patientsListToReschedule: [],
        draftModeOn: false,

        filterPriorityWorklist: [],
        filterWhoCanOperateWorklist: [],
        filterConsultantWorklist: [],
        filterSpecialityWorklist: [],
        filterPatientWorklist: "",

        isInitRenderCalendar: true
    },
    reducers: {
        setFilterPriorityWorklist: (state, filterPriorityWorklist) => {
            state.filterPriorityWorklist = filterPriorityWorklist.payload;
        },
        setInitRenderCalendar: (state, isInitRenderCalendar) => {
            state.isInitRenderCalendar = isInitRenderCalendar.payload;
        },
        setFilterWhoCanOperateWorklist: (state, filterWhoCanOperateWorklist) => {
            state.filterWhoCanOperateWorklist = filterWhoCanOperateWorklist.payload;
        },
        setFilterConsultantWorklist: (state, filterConsultantWorklist) => {
            state.filterConsultantWorklist = filterConsultantWorklist.payload;
        },
        setFilterSpecialityWorklist: (state, filterSpecialityWorklist) => {
            state.filterSpecialityWorklist = filterSpecialityWorklist.payload;
        },
        setFilterPatientWorklist: (state, filterPatientWorklist) => {
            state.filterPatientWorklist = filterPatientWorklist.payload;
        },
        setPatientFilter: (state, patientsFilter) =>{
            state.patientsFilter = patientsFilter.payload
        },
        setContentView: (state, view) =>{
            state.admissionContentView = view.payload
        },
        setDraftModeOn: (state, draftModeOn) =>{
            state.draftModeOn = draftModeOn.payload
        },
        setProcedureFilter: (state, procedureFilter) =>{
            state.procedureFilter = procedureFilter.payload
        },
        setHourHeight: (state, hourHeight) => {
            state.hourHeight = hourHeight.payload;
        },
        setFilterAnaestheticType: (state, filterAnaestheticType) => {
            state.filterAnaestheticType = filterAnaestheticType.payload;
        },
        setFilterPriority: (state, filterPriority) => {
            state.filterPriority = filterPriority.payload;
        },
        setFiltersStatus: (state, filtersStatus) => {
            state.filtersStatus = filtersStatus.payload;
        },
        setSpecialtiesFilter: (state, specialtiesFilter) => {
            state.specialtiesFilter = specialtiesFilter.payload;
        },
        setConsultantsFilter: (state, consultantsFilter) => {
            state.consultantsFilter = consultantsFilter.payload;
        },
        setSurgeonsFilter: (state, surgeonsFilter) => {
            state.surgeonsFilter = surgeonsFilter.payload;
        },
        setAnaesthetistsFilter: (state, anaesthetistsFilter) => {
            state.anaesthetistsFilter = anaesthetistsFilter.payload;
        },
        setWorklistFilterColumns: (state, action) => {
            state.worklistFilterColumns = action.payload;
        },
        setTheatresDict: (state, theatresDict) => {
            state.theatresDict = theatresDict.payload;
        },
        setAllTheatersDict: (state, theatresDict) => {
            state.allTheatresDict = theatresDict.payload;
        },
        setSpecialtiesDict: (state, specialtiesDict) => {
            state.specialtiesDict = specialtiesDict.payload;
        },
        setCalendarView: (state, calendarView) => {
            state.calendarView = calendarView.payload;
        },
        setConfig: (state, config) => {
            state.config = config.payload;
        },
        setStartDay: (state, startDay) => {
            state.startDay = startDay.payload;
        },
        setAdmissionType: (state, admissionType) => {
            state.admissionType = admissionType.payload;
        },
        setSelectedTime: (state, selectedTime) => {
            state.selectedTime = selectedTime.payload;

            state.operationsFiltered = state.operations?.filter(operation => {
                return operation.sessiosObj?.theatre.description === state.selectedTheatre?.description
            });

            state.sessionsFiltered = state.sessions?.filter(session => {
                return session.theatre.description === state.selectedTheatre?.description
            });
        },
        setSelectedTheatre: (state, selectedTheatre) => {
            state.selectedTheatre = selectedTheatre.payload;

            state.sessionsFiltered = state.sessions?.filter(session => {
                return session.theatre.description === state.selectedTheatre?.description
            });

            state.operationsFiltered = state.operations?.filter(operation => {
                return operation.sessiosObj?.theatre.description === state.selectedTheatre?.description
            });

        },
        setJumpToTheatre: (state, selectedTheatre) => {
            state.jumpToTheatre = selectedTheatre.payload;
        },
        setMarkedOperation: (state, markedOperation) => {
            if(!markedOperation.payload)  {
                state.markedOperation = null;
                state.operationToScroll = null;
            }

            if(state.markedOperation && state.markedOperation.id === markedOperation.payload.id
                && state.markedOperation.__version === markedOperation.payload.__version) {
                // state.admissionContentView = contentViewTypes.INFORMATION
            } else
                state.markedOperation = markedOperation.payload;
        },
        setOperationToScroll: (state, operationToScroll) => {
            if(!operationToScroll.payload || (state.operationToScroll && state.operationToScroll === operationToScroll.payload))
                state.operationToScroll = null;
            else
                state.operationToScroll = operationToScroll.payload;
        },
        setOperationsData: (state, operations) => {
            state.operationsObject = operations.payload;
        },
        setOperations: (state, operations) => {
            state.operations = operations.payload;

            let operationsObj = {};

            state.operations?.forEach((operation) => {
                operationsObj[operation.id] = operation
            })

            state.operationsObject = operationsObj;

            state.operationsFiltered = operations.payload?.filter(operation => {
                return operation.sessiosObj?.theatre.description === state.selectedTheatre?.description;
            });
        },
        setWorklistOperationsData: (state, operations) => {
            state.worklistOperations = operations.payload;
        },
        setUnscheduledOperationsData: (state, operations) => {
            state.unscheduledOperation = _.uniqBy( operations.payload.__data, "id");
            state.unscheduledOperationLength = operations.payload.__size;
        },
        setNextUnscheduledOperationsData: (state, operations) => {
            state.unscheduledOperation = _.uniqBy([...state.unscheduledOperation, ...operations.payload], "id");
        },
        setSessionsData: (state, sessions) => {
            state.sessions = sessions.payload;

            state.sessionsFiltered = state.sessions?.filter(session => {
                return session.theatre.description === state.selectedTheatre?.description;
            });
        },
        setOperationsStatus: (state, operationsStatus) => {
            state.operationsStatus = operationsStatus.payload;
        },
        setPatientsListToReschedule: (state, patientsListToReschedule) => {
            state.patientsListToReschedule = patientsListToReschedule.payload;
        },
    },
});

export const {setOperationsData,setOperations, setUnscheduledOperationsData, setProcedureFilter,
    setNextUnscheduledOperationsData,setSpecialtiesFilter, setHourHeight, setConsultantsFilter, setJumpToTheatre,
    setSessionsData, setOperationsStatus, setStartDay, setFilterPriority, setFilterAnaestheticType,
    setMarkedOperation, setSelectedTheatre, setFiltersStatus,setPatientsListToReschedule,
    setPatientFilter, setSurgeonsFilter, setAnaesthetistsFilter,setInitRenderCalendar,
    setFilterPriorityWorklist, setFilterWhoCanOperateWorklist, setFilterConsultantWorklist,setFilterSpecialityWorklist, setFilterPatientWorklist,
    setOperationToScroll, setWorklistOperationsData, setContentView, setAdmissionType,setDraftModeOn,
    setCalendarView, setConfig, setTheatresDict, setAllTheatersDict, setSpecialtiesDict} = bookedAdmissions.actions;

export const getInitRenderCalendar = state => state.bookedAdmissions.isInitRenderCalendar;
export const getFilterPriorityWorklist = state => state.bookedAdmissions.filterPriorityWorklist;
export const getFilterWhoCanOperateWorklist = state => state.bookedAdmissions.filterWhoCanOperateWorklist;
export const getFilterConsultantWorklist = state => state.bookedAdmissions.filterConsultantWorklist;
export const getFilterSpecialityWorklist = state => state.bookedAdmissions.filterSpecialityWorklist;
export const getFilterPatientWorklist = state => state.bookedAdmissions.filterPatientWorklist;
export const getPatientsFilter = state => state.bookedAdmissions.patientsFilter;
export const getSurgeonsFilter = state => state.bookedAdmissions.surgeonsFilter;
export const getAnaesthetistsFilter = state => state.bookedAdmissions.anaesthetistsFilter;
export const getProcedureFilter = state => state.bookedAdmissions.procedureFilter;
export const getDraftModeOn = state => state.bookedAdmissions.draftModeOn;
export const getContentView = state => state.bookedAdmissions.admissionContentView;
export const getHourHeight = state => state.bookedAdmissions.hourHeight;
export const getFiltersStatus = state => state.bookedAdmissions.filtersStatus;
export const getCalendarView = state => state.bookedAdmissions.calendarView;
export const getSpecialtiesFilter = state => state.bookedAdmissions.specialtiesFilter;
export const getConsultantsFilter = state => state.bookedAdmissions.consultantsFilter;
export const getOperationsFiltered = state => state.bookedAdmissions.operationsFiltered;
export const getOperations = state => state.bookedAdmissions.operations;
export const getOperationsObject = state => state.bookedAdmissions.operationsObject;
export const getWorklistOperations = state => state.bookedAdmissions.worklistOperations;
export const getWorklistOperationsLength = state => state.bookedAdmissions.worklistOperationsLength;
export const getUnscheduledOperations = state => state.bookedAdmissions.unscheduledOperation;
export const getUnscheduledLength = state => state.bookedAdmissions.unscheduledOperationLength;
export const getSessions = state => state.bookedAdmissions.sessions;
export const getSessionsFiltered = state => state.bookedAdmissions.sessionsFiltered;
export const getOperationsStatus = state => state.bookedAdmissions.operationsStatus;
export const getStartDay = state => state.bookedAdmissions.startDay;
export const getMarkedOperation = state => state.bookedAdmissions.markedOperation;
export const getSelectedTheatre = state => state.bookedAdmissions.selectedTheatre;
export const getSelectedTime = state => state.bookedAdmissions.selectedTime;
export const getAdmissionType = state => state.bookedAdmissions.admissionType;
export const getConfig = state => state.bookedAdmissions.config;
export const getTheatresDict = state => state.bookedAdmissions.theatresDict;
export const getAllTheatresDict = state => state.bookedAdmissions.allTheatresDict;
export const getSpecialtiesDict = state => state.bookedAdmissions.specialtiesDict;
export const getFilterPriority = state => state.bookedAdmissions.filterPriority;
export const getFilterAnaestheticType = state => state.bookedAdmissions.filterAnaestheticType;
export const getOperationToScroll = state => state.bookedAdmissions.operationToScroll;
export const getPatientsListToReschedule = state => state.bookedAdmissions.patientsListToReschedule;

export const setNewStartDay = (startDay) => (dispatch, getState) => {
    dispatch(setDraftModeOn(false));
    dispatch(setSessionsData([]))
    dispatch(setOperationsData({}))

    dispatch(setStartDay(startDay.toString()));
    dispatch(loadSessions(startDay, getState().bookedAdmissions.calendarView, getState().bookedAdmissions.admissionType));
};

export const setNewView = (startDay, calendarView) => (dispatch, getState) => {
    dispatch(setDraftModeOn(false));
    dispatch(setSessionsData([]))
    dispatch(setOperationsData({}))

    dispatch(setStartDay(startDay.toString()));
    dispatch(setCalendarView(calendarView));

    dispatch(loadSessions(startDay, calendarView, getState().bookedAdmissions.admissionType));
};

export const setNewCalendarView = (calendarView) => (dispatch, getState) => {
    dispatch(setDraftModeOn(false));
    dispatch(setSessionsData([]))
    dispatch(setOperationsData({}))

    dispatch(setCalendarView(calendarView));

    let startDay = moment(getState().bookedAdmissions.startDay)
    if(calendarView === CalendarViews.month) dispatch(setStartDay(startDay.startOf('month')));

    dispatch(loadSessions(startDay, calendarView, getState().bookedAdmissions.admissionType));

};

export const reload = () => (dispatch, getState) => {
    dispatch(loadSessions(moment(getState().bookedAdmissions.startDay), getState().bookedAdmissions.calendarView, getState().bookedAdmissions.admissionType));
    dispatch(loadUnscheduledOperations());
};

export const clearFilters = () => (dispatch, getState) => {
    dispatch(setSpecialtiesFilter([]))
    dispatch(setConsultantsFilter([]))
    dispatch(setSurgeonsFilter([]))
    dispatch(setAnaesthetistsFilter([]))
    dispatch(setFilterPriority([]))
    dispatch(setProcedureFilter(null))
    dispatch(setFilterAnaestheticType([]))
};

export const clearWorkListFilters = () => (dispatch, getState) => {
    dispatch(setFilterConsultantWorklist([]))
    dispatch(setFilterPatientWorklist(""))
    dispatch(setFilterPriorityWorklist([]))
    dispatch(setFilterSpecialityWorklist([]))
    dispatch(setFilterWhoCanOperateWorklist([]))
};


export const setTheatreById = (id) => (dispatch, getState) => {
    let theatreDict = getState().bookedAdmissions.theatresDict;
    let newTheatre = theatreDict.find((item) => item.__id === id);
    dispatch(setSelectedTheatre(newTheatre))
};

export const setNewAdmissionType = (admissionType) => (dispatch, getState) => {
    dispatch(setDraftModeOn(false));
    dispatch(setSessionsData([]))
    dispatch(setOperationsData({}))

    dispatch(setMarkedOperation(null))
    dispatch(setOperationToScroll(null))

    dispatch(setAdmissionType(admissionType))
    dispatch(getTheatres());
    dispatch(setCalendarView(CalendarViews.month));
    dispatch(clearFilters());
    dispatch(setNewStartDay(moment().startOf('month')));
    dispatch(loadUnscheduledOperations(admissionType));
};

export const loadUnscheduledOperations = (admissionType) => (dispatch, getState) => {
    API.getUnscheduledOperation(1, dispatch(getFilter())).then(data => {
        dispatch(setUnscheduledOperationsData(data));

    }).catch(function (error) {
        // TODO: error handler !!!
        console.error(error);
    });

};

export const loadUnscheduledOperationsWithOperationOnList = (admissionType, op) => (dispatch, getState) => {
    API.getUnscheduledOperation(1, dispatch(getFilter())).then(data => {
        data.__data.push(op)
        dispatch(setUnscheduledOperationsData(data));

    }).catch(function (error) {
        // TODO: error handler !!!
        console.error(error);
    });

};

export const loadNextUnscheduledOperations = (page) => (dispatch, getState) => {
    API.getUnscheduledOperation(page, dispatch(getFilter())).then(operations => {
        dispatch(setNextUnscheduledOperationsData(operations.__data));

    }).catch(function (error) {
        // TODO: error handler !!!
        console.error(error);
    });

};

export const getTheatres = () => (dispatch, getState) => {
    let type = getState().bookedAdmissions.admissionType;
    API.getTheatres(type).then(theatres => {
         //   let theatreFiltered = theatres.filter(theatre => theatre.active);
            dispatch(setTheatresDict(theatres));
            let jumpTo = getState().bookedAdmissions.jumpToTheatre;
            if(jumpTo !== ""){
                let jumpT = _.find(theatres, {__id: jumpTo});
                dispatch(setSelectedTheatre(jumpT));
                dispatch(setJumpToTheatre(""));
            } else {
                if (type === admissionViewTypes.THEATRES) dispatch(setSelectedTheatre(theatres?.[0]));
                else {
                    let mdu = _.find(theatres, {description: "Medical Day Unit"});
                    dispatch(setSelectedTheatre(mdu ? mdu : theatres?.[0]));
                }
            }
        })
        .catch(err => {
            console.error(err);

        })
        .finally(() => {
            // dispatch(setLoading(false));
        });
};

export const getSpecialties = () => (dispatch, getState) => {
    API.getDictByURL("/$dict/Specialties?$filter=metadata.bookAdmission%20eq%20true&$sort=description").then(bookAdmissionSpecialties => {
            dispatch(setSpecialtiesDict(bookAdmissionSpecialties.__data));
        })
        .catch(err => {
            console.error(err);
        })
        .finally(() => {
            // dispatch(setLoading(false));
        });
};

export const getAdmissionConfig = () => (dispatch, getState) => {
    API.getAdmissionConfig().then(config => {
        dispatch(setConfig(config));
    }).catch(function (error) {
        // TODO: error handler !!!
        console.error(error);
    });

};

export const getSession = (id) => (dispatch, getState) => {
    let session = getState().bookedAdmissions.sessions.find((session) => session.id === id);
    return session;
};


export const loadSessions = (from, calendarView, opType) => (dispatch, getState) => {

    if(!from) from = moment().startOf("month");

    const to = (() => {
        switch (calendarView) {
            case CalendarViews.days4:
                return moment(from).add(3, "day");
            case CalendarViews.days1:
                return moment(from);
            case CalendarViews.days5:
                return moment(from).add(4, "day");
            case CalendarViews.days7:
                return moment(from).add(6, "day");
            case CalendarViews.month:
            default:
                return moment(from).endOf("month");
        }
    })();
    let timezone =  'Europe/London';

    let londonDateFrom = moment.tz((from.format("YYYY-MM-DD")+'T00:00:00'), timezone);
    let londonDateTo = moment.tz((to.add(1,"day").format("YYYY-MM-DD")+'T00:00:00'), timezone);


    API.getSesions(from.format("YYYY-MM-DD"), to.format("YYYY-MM-DD"), opType)
        .then(sessions => {
            dispatch(setSessionsData(sessions));

            const sessionsObj = {};
            sessions.forEach(session => {
                sessionsObj[session.id] = session;
            });

            let from2 = londonDateFrom.utc().format("YYYY-MM-DD HH:mm");
            let type2 = opType === "TCI" ?  '["TCI"]' : '["MDU"]';

            let filter = `bookedDate ge_dt '${from2}' and bookedDate le_dt '${londonDateTo.utc().format("YYYY-MM-DD HH:mm" )}' and opType in '${type2}'`;

            API.getOperation(filter)
                .then(operations => {
                    operations?.forEach(op => {
                        op["sessiosObj"] = sessionsObj[op.bookedSession];
                    });

                    dispatch(setOperations(operations));
                })
                .catch(error => {
                    // TODO: error handler !!!
                    console.error(error);
                });
        })
        .catch(error => {
            // TODO: error handler !!!
            console.error(error);
        });

};

function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\\\$&').replace(/[']/g, "\\'"); // $& means the whole matched string
}

export const getFilter = () => (dispatch, getState) => {
    let filter = "";
    let type = getState().bookedAdmissions.admissionType === "TCI" ? '["TCI"]' : '["MDU"]';

    // if(getState().bookedAdmissions.operationsStatus === admissionStatusTypes.WORKLIST) {
    filter += `status ne 'WORKLIST' and  ` ;//status ne 'history' and`;
    // }
    if(getState().bookedAdmissions.filtersStatus === StatusTypes.ACTIVE) {
        filter += `(cancelInfo ex 0 or cancelInfo.status eq 'rebook') `;
    } else {
        let date  = moment().add(-28, "days").format("YYYY-MM-DD");
        filter += `(cancelInfo.status eq 'delete' and cancelInfo.date gt_dt '${date}') `;
    }

    filter += `and opType in '${type}' `;

    if(getState().bookedAdmissions.specialtiesFilter && getState().bookedAdmissions.specialtiesFilter.length > 0) {
        //  filter += `and procedures.specialty eq '${getState().bookedAdmissions.specialtiesFilter.__code}'`;

        if(!filter) filter = "";
        else filter += " AND ";
        filter += `procedures.specialty in '[`


        getState().bookedAdmissions.specialtiesFilter.forEach((p, index) => {
            if(index > 0) filter += ","
            filter += `"${p.__code}"`
        })
        filter += `]'`

    }

    if (getState().bookedAdmissions.consultantsFilter && getState().bookedAdmissions.consultantsFilter.length > 0) {
        if(!filter) filter = "";
        else filter += " AND ";
        filter += `overseeingConsultant.id in '[`


        getState().bookedAdmissions.consultantsFilter.forEach((p, index) => {
            if(index > 0) filter += ","
            filter += `"${p.id}"`
        })
        filter += `]'`

    }

    if(getState().bookedAdmissions.patientsFilter) {
        //D802860
        let filterArray = getState().bookedAdmissions.patientsFilter.split(" ");

        let pattern = /\d{2}\/\d{2}\/\d{4}/;
        let hospitalNumbers = filterArray.filter((f) => f.match(/[0-9]/)).filter((f) => !f.match(pattern));
        let dob = filterArray.filter((f) => f.match(pattern));
        let names = filterArray.filter((f) => !f.match(/[0-9]/)).filter((f) => !f.match(pattern));

        if(hospitalNumbers) {
            filter += ` and patientId regex '(?i)(?:${hospitalNumbers.join("|")})'`;
        }
        if(dob.length) {
            let dobString = moment(dob, "MM/DD/YYYY").format("YYYY-MM-DD")
            filter += ` and patientDob eq_dt '${dobString}' `;
        }

        if(names.length) {
            filter += ` and patientName regex '(?i)(?:.*${names.join(".*|.*")}.*)'`;
        }
    }

    if(getState().bookedAdmissions.procedureFilter) {
        filter += `and procedures.description eq '${getState().bookedAdmissions.procedureFilter.__description}'`;
    }

    if(getState().bookedAdmissions.filterAnaestheticType.length) {
        filter += `and anaestheticType.code in '[`


        getState().bookedAdmissions.filterAnaestheticType.forEach((type, index) => {
            if(index > 0) filter += ","
            filter += `"${type.code}"`
        })
        filter += `]'`

    }
    if(getState().bookedAdmissions.filterPriority.length) {
        if(!filter) filter = "";
        else filter += " AND ";
        filter += `priority.description in '[`


        getState().bookedAdmissions.filterPriority.forEach((p, index) => {
            if(index > 0) filter += ","
            filter += `"${p.description}"`
        })
        filter += `]'`
    }

    return filter;
}

export const countDays = () => (dispatch, getState) => {
    let days = 1;

    switch(getState().bookedAdmissions.calendarView) {
        case CalendarViews.month:
            days = moment(getState().bookedAdmissions.startDay).daysInMonth()
            break;
        case CalendarViews.days4:
            days = 4
            break;
        case CalendarViews.days5:
            days = 5
            break;
        case CalendarViews.days7:
            days = 7
            break;
    }

    return days;

};

export const handleOperationClick = (operation) => (dispatch, getState) => {

    if(!operation.bookedSession){
        let status = (operation.cancelInfo && operation.cancelInfo.status === "delete")? StatusTypes.CANCELED: StatusTypes.ACTIVE;

        dispatch(setFiltersStatus(status))
        dispatch(setNextUnscheduledOperationsData([operation]));
        dispatch(setOperationsStatus(admissionStatusTypes.UNSCHEDULED))
        dispatch(setMarkedOperation(operation));
        dispatch(setOperationToScroll(operation.id));
        dispatch(setNewView(moment().startOf("month"), CalendarViews.month));
        dispatch(setContentView(contentViewTypes.INFORMATION))
    } else {
        API.getSesionsByIds([operation.bookedSession]).then(data => {
            let session = data.__data[0];

            dispatch(setOperationsStatus(admissionStatusTypes.SCHEDULED))
            dispatch(setTheatreById(session.theatre.__id))
            dispatch(setNewView(moment(session.day), CalendarViews.days1));
            dispatch(setMarkedOperation(operation));
            dispatch(setOperationToScroll(operation.id))
            dispatch(setContentView(contentViewTypes.INFORMATION))

        }).catch(function (error) {
            // TODO: error handler !!!
            console.error(error);
        });
    }


}


export const handleSessionClick = (session) => (dispatch, getState) => {
    const admissionType = session.opType === "MDU" ? admissionViewTypes.MDU : admissionViewTypes.THEATRES;
    dispatch(setOperationsStatus(admissionStatusTypes.SCHEDULED))
    dispatch(setAdmissionType(admissionType));
    dispatch(setTheatreById(session.theatre.__id))
    dispatch(setNewView(moment(session.day), CalendarViews.days1));
}

export const filterScheduleList = () =>  (dispatch, getState) => {
    if (getState().bookedAdmissions.admissionType === admissionViewTypes.THEATRES) {

        let filterOp = getState().bookedAdmissions.operationsFiltered;

        if (getState().bookedAdmissions.filterPriority && getState().bookedAdmissions.filterPriority.length) {
            filterOp = filterOp.filter((op) => {
                return getState().bookedAdmissions.filterPriority.some((p) => {
                    return p.code === Number(op.priority.code)
                })
            });
        }

        if (getState().bookedAdmissions.filterAnaestheticType && getState().bookedAdmissions.filterAnaestheticType.length) {
            filterOp = filterOp.filter((op) => {
                return getState().bookedAdmissions.filterAnaestheticType.some((a) => {
                    return a.code === Number(op.anaestheticType.code)
                })
            });
        }

        // if (getState().bookedAdmissions.specialtiesFilter) {
        //     filterOp = filterOp.filter((op) => {
        //         return op.procedures.some((procedure) => {
        //             return procedure.specialty === getState().bookedAdmissions.specialtiesFilter.__code
        //         })
        //     });
        // }
        if (getState().bookedAdmissions.consultantsFilter.length) {
            filterOp = filterOp.filter((op) => {
                return getState().bookedAdmissions.consultantsFilter.some((consultant) => {
                    return consultant.id === op.overseeingConsultant?.id
                })
            });
        }

        if (getState().bookedAdmissions.patientsFilter) {
            let filterArray = getState().bookedAdmissions.patientsFilter.split(" ");

            let patternDOB = /\d{2}\/\d{2}\/\d{4}/;
            let hospitalNumbers = filterArray.filter((f) => f.match(/[0-9]/)).filter((f) => !f.match(patternDOB));
            let dob = filterArray.filter((f) => f.match(patternDOB));
            let names = filterArray.filter((f) => !f.match(/[0-9]/)).filter((f) => !f.match(patternDOB));

            if (dob.length) {
                filterOp = filterOp.filter((op) => {
                    return dob.some((a) => {
                        return a === moment(op.patientDob).format("MM/DD/YYYY")
                    })
                });
            }
            if (hospitalNumbers.length) {
                filterOp = filterOp.filter((op) => {
                    return hospitalNumbers.some((a) => {
                        return a === op.patientId
                    })
                });
            }

            if (names.length) {
                const regex = new RegExp(names.join("|"), "i");
                filterOp = filterOp.filter((op) => regex.test(op.patientName));
            }

        }

        return filterOp;

    } else {
        if (!getState().bookedAdmissions.procedureFilter)
            return getState().bookedAdmissions.operationsFiltered;
        else
            return getState().bookedAdmissions.operationsFiltered.filter((op) => {
                return op.procedures.some((procedure) => {
                    return getState().bookedAdmissions.procedureFilter.__id === procedure.__id
                })
            });
    }
}

export const setDefaultFilterToMe = (userName) => (dispatch, getState) => {
    let urlConsultant = `/admission/person/consultant?userName=${userName}`;
    let urlSurgeon = `/admission/person/surgeon?userName=${userName}`;
    let urlAnaesthetist = `/admission/person/anaesthetist?userName=${userName}`;

    API.getDictByURL(urlConsultant).then(dictData => {
        if (dictData && !_.isEmpty(dictData)) {
            dispatch(setConsultantsFilter(dictData))
        } else {
            dispatch(setConsultantsFilter([]))
        }
    }).catch(function (error) {
        console.error("Consultant Filter", error);
    });

    API.getDictByURL(urlSurgeon).then(dictData => {
        if (dictData && !_.isEmpty(dictData)) {
            dispatch(setSurgeonsFilter(dictData))
        } else {
            dispatch(setSurgeonsFilter([]))
        }
    }).catch(function (error) {
        console.error("Surgeons Filter", error);
    });

    API.getDictByURL(urlAnaesthetist).then(dictData => {
        if (dictData && !_.isEmpty(dictData)) {
            dispatch(setAnaesthetistsFilter(dictData))
        } else {
            dispatch(setAnaesthetistsFilter([]))
        }
    }).catch(function (error) {
        console.error("Anaesthetists Filter", error);
    });

};

export default bookedAdmissions.reducer;